/**
 * LoginButton component.
 * @module components/ItaliaTheme/Header/HeaderSlim/LoginButton
 */

import React, { useEffect } from 'react';
import { Button } from 'design-react-kit';
import { useHistory } from 'react-router-dom';
import { getUnibaLoginButton } from 'design-comuni-plone-theme/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

const LoginButton = ({ children, baseLoginUrl, size = 'full' }) => {
    const intl = useIntl();
    const history = useHistory();
    const dispatch = useDispatch();
    const showLoginButton = useSelector(
        (state) => state.unibaLoginButton.result
    );

    useEffect(() => {
        dispatch(getUnibaLoginButton());
    }, [dispatch]);

    const handleLoginClick = (e) => {
        e.preventDefault();
        const currentPath = location.pathname + location.search;
        const cameFrom = encodeURIComponent(currentPath);
        const separator = baseLoginUrl.includes('?') ? '&' : '?';
        const loginUrl = `${baseLoginUrl}${separator}return_url=${cameFrom}`;
        history.push(loginUrl);
    };

    return (baseLoginUrl && showLoginButton == true) ? (
        <Button
            className="btn-icon login-button"
            href={baseLoginUrl}
            color="primary"
            icon={false}
            size={size}
            tag="a"
            data-element="personal-area-login"
            onClick={handleLoginClick}
            aria-label={intl.formatMessage({id: 'Accedi all\'area personale'})}
        >
            {children}
        </Button>
    ) : (
        <></>
    );
};

export default LoginButton;
